<template>
  <footer class="site-footer" role="contentinfo">
    <div class="footer-inner">
      <div class="company-info">
        <h2 class="company-name">{{ companyName }}</h2>
        <div class="contact-info">
          <p class="contact-item">电话：{{ phone }}（工作日：上午 9:00-12:00，下午 13:00-18:00）</p>
          <p class="contact-item">邮箱：{{ email }}</p>
          <p class="contact-item">公司地址：{{ address }}</p>
          <p class="contact-item">办公室：{{ shenzhenAddress }}</p>
        </div>
      </div>
    </div>
    
    <!-- 风险提示和版权信息 -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        <p class="risk-warning">{{ riskWarning }}</p>
        <p class="copyright">{{ copyrightInfo }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      companyName: '中政量化（广州）技术研究有限公司',
      phone: '18026209598',
      email: 'zhongzhengquant@163.com',
      address: '广东省广州市海珠区广州大道南1604号',
      shenzhenAddress: '广州市海珠区广州大道南1603号',
      riskWarning: '本网站所有内容仅供参考，如有与本公司相关公告及基金法律文件不符，以相关公告及基金法律文件为准。市场有风险，投资需谨慎。',
      copyrightInfo: 'Copyright © 2026 中政量化 版权所有 ICP备案号: 粤ICP备2026004300号-1'
    };
  }
};
</script>

<style scoped>
/* Footer 主框架 */
.site-footer {
  color: #fff;
  background: #043294;
  position: relative;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}

/* 公司信息 */
.company-info {
  flex: 1;
  min-width: 300px;
}

.company-name {
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 20px;
  color: #fff;
}

.contact-info {
  font-size: 14px;
  line-height: 2;
  color: #fff;
}

.contact-item {
  margin: 0 0 10px;
}

/* 底部信息 */
.footer-bottom {
  background: #043294;
  padding: 20px 0;
  color: #fff;
  margin-top: 0;
}

.footer-bottom-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  line-height: 1.5;
}

.risk-warning {
  margin: 0;
}

.copyright {
  margin: 0;
}

/* 响应式 */
@media (max-width: 768px) {
  .footer-inner {
    padding: 30px 20px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .company-info {
    min-width: auto;
  }
  
  .company-name {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .contact-info {
    font-size: 13px;
  }
  
  .footer-bottom-inner {
    padding: 0 20px;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .footer-inner {
    padding: 20px 15px;
    gap: 20px;
  }
  
  .company-name {
    font-size: 16px;
  }
  
  .contact-info {
    font-size: 12px;
  }
  
  .footer-bottom-inner {
    padding: 0 15px;
    font-size: 10px;
  }
}
</style>